"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = useRowActions;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_redux_1 = require("react-redux");
var letsachieve_1 = require("../../../../../../api/letsachieve");
var label_1 = require("../../../../../../controls/label");
var permissions_1 = require("../../../../../../hooks/permissions");
var IUser_1 = require("../../../../../../interfaces/IUser");
var main_1 = require("../../../../../../reducers/slices/main");
function useRowActions() {
    var _this = this;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, letsachieve_1.useDeleteCurrencyMutation)(), deleteCurrency = _a[0], isLoading = _a[1].isLoading;
    var canDelete = (0, permissions_1.usePermission)(IUser_1.IPermissions.WALLET).canDelete;
    var confirmDelete = (0, react_3.useCallback)(function (currency) {
        dispatch((0, main_1.setContentModal)({
            title: "Confirm deletion of '".concat(currency === null || currency === void 0 ? void 0 : currency.name, "' currency"),
            content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Deleting this currency can have side effects, such as your customers losing access to balances held in it.", textColor: "text-inputText", center: true }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Are you sure you wish to continue?", textColor: "text-inputText", center: true }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row pt-4 gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "tertiary", isPending: isLoading, onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "danger", isPending: isLoading, onPress: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var error_1;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                _b.trys.push([0, 2, , 3]);
                                                // invalidating the Currency tag refreshes the list, so there is no follow-up fetch here
                                                return [4 /*yield*/, deleteCurrency(currency._id).unwrap()];
                                            case 1:
                                                // invalidating the Currency tag refreshes the list, so there is no follow-up fetch here
                                                _b.sent();
                                                dispatch((0, main_1.setMessageModal)({ title: "Success!", messages: ["Successfully deleted currency."] }));
                                                dispatch((0, main_1.setContentModal)(null));
                                                return [3 /*break*/, 3];
                                            case 2:
                                                error_1 = _b.sent();
                                                dispatch((0, main_1.setMessageModal)({
                                                    title: "Something went wrong when deleting your currency!",
                                                    messages: [(_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _a !== void 0 ? _a : "The request was unsuccessful."],
                                                }));
                                                return [3 /*break*/, 3];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); }, children: "Continue" })] })] })),
        }));
    }, [dispatch, deleteCurrency, isLoading]);
    var rowActions = (0, react_3.useCallback)(function (currency) {
        return canDelete
            ? [
                {
                    key: "delete",
                    element: ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "danger-soft", "aria-label": "Delete ".concat(currency.name), onPress: function () { return confirmDelete(currency); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:delete", className: "text-danger", width: 18, height: 18 }) }, "delete")),
                },
            ]
            : [];
    }, [confirmDelete, canDelete]);
    return { rowActions: rowActions };
}
